// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteSmsSendBody = {
  requestId?: string | null;
  poolId: string;
  phoneNumbers: string[];
};

export type typeInviteSmsSendOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    sentCount: number;
    notSentCount: number;
    outcomeUnknownCount: number;
    isSmsAvailable: boolean;
  };
};

export type typeInviteSmsSendOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteSmsSendOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteSmsSendOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteSmsSendBody = {
  type: "object",
  properties: {
    requestId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    phoneNumbers: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["poolId", "phoneNumbers"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteSmsSend(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteSmsSendBody);
  }

  return async function postInviteSmsSend(
    payload: typeInviteSmsSendBody,
  ): Promise<typeInviteSmsSendOutput200 | typeInviteSmsSendOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteSmsSend" failed before calling the network. #bc0d5350a316`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#bc0d5350a316" },
        },
        data: null,
      } as typeInviteSmsSendOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/sms-send`,
      httpMethod: "POST",
      options,
    })) as typeInviteSmsSendOutput200 | typeInviteSmsSendOutput400;
  };
}
